module.exports = __webpack_public_path__ + "img/chart_inactive_24dp.7a932b84.png";